import Title from "@material-symbols/svg-500/rounded/title.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

export const EditorTitleIcon = memo((props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Title });
	return <Icon />;
});
